import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import GetProfile from '../layouts/header/GetProfile';
import Loadable from '../layouts/loader/Loadable';
import Login from '../views/auth/Login';
import LoginFormik from '../views/auth/LoginFormik';
import RecoverPwd from '../views/auth/RecoverPwd';
import Invoices from '../views/zoho/invoices/invoices';


/****Layouts*****/

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));

/***** Auth Pages ****/
const Error = Loadable(lazy(() => import('../views/auth/Error')));
const RecoverPassword = Loadable(lazy(() => import('../views/auth/RecoverPassword')));
const MyProfile = Loadable(lazy(()=> import('../views/dashboards/MyProfile')))

// eslint-disable-next-line no-unused-vars
const InvoiceDetails = Loadable(lazy(()=> import('../views/zoho/invoices/invoice-details')))


/*****Routes******/
const ThemeRoutes = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', element: <Navigate to="/auth/loginform" /> },
      {path : '/myprofile', name : 'GetProfile', exact:true, element:<GetProfile/>},
      {path : '/myprofile', name : 'MyProfile', exact : true, element : <MyProfile/>},
      {path : '/apps/invoices', name : 'Invoices', exact:true, element:<Invoices/>},
      {path : '/apps/invoices/details/:id', name:'InvoiceDetails', exact:true, element:<InvoiceDetails/>},
      
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: 'login', element: <LoginFormik /> },
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
      { path: 'loginform', element: <Login/> },
      { path: 'recover', element: <RecoverPassword /> },
      { path: 'recoverpassword/:code', element: <RecoverPwd /> },
    ],
  },
];

export default ThemeRoutes;
